<template >
  <div>
    <a v-if="isUrl(textToCopy)" :href="textToCopy">{{textToCopy}} </a>
    <span v-else >{{textToCopy}} </span>
    <a-button
      size="small"
      v-clipboard:copy="textToCopy"
      v-clipboard:success="onCopy"
    >
      Скопировать
    </a-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CopyText',
  props: ['textToCopy'],
  methods: {
    isUrl(string) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var r = new RegExp(urlRegex)
      return r.test(string)
    },
    onCopy() {return this.$message.success('Скопировано')},
  }
}
</script>

<style scoped lang='scss'>
@import '../../css/var.scss';

</style>
